<template>
  <b-modal id="updateCorrespondenceThreadModal" ref="updateCorrespondenceThreadModal" size="xs" hide-footer @hidden="$emit('reset')">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('views.excmcorrespondence.list.setContractor') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="form-group">
          <label class="form-control-label">{{ $t('views.excmcorrespondence.list.setContractor') }}:</label><br>
          <base-select-input
              v-model="updateCorrespondenceThread.idContractor"
              :search-callback="userDataSearchCallback"
              :display-values="['fullName', 'firmname1']"
              :query-param="'userdata'"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
          ></base-select-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="btn float-left btn-info mr-1" @click="updateItem()">{{ $t('buttons.submit') }}</b-button>
        <b-button class="btn float-left btn-danger" @click="hideModal()">{{ $t('buttons.cancel') }}</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import ApiService from '@/utils/ApiService'
export default {
  name: 'updateCorrespondenceThreadRelatedUserDataModal',
  components: { BaseSelectInput },
  props: {
    updateCorrespondenceThread: {}
  },
  mounted () {
    if (this.updateCorrespondenceThread) {
      this.$refs.updateCorrespondenceThreadModal.show()
    }
  },
  methods: {
    hideModal () {
      this.$refs.updateCorrespondenceThreadModal.hide()
      this.$emit('reset')
    },
    resetUpdateCorrespondenceThread () {
      this.$emit('reset', true)
    },
    async updateItem () {
      const response = await new ApiService(this.updateCorrespondenceThread['@id']).put(this.updateCorrespondenceThread)
      if (response.status === 200) {
        this.resetUpdateCorrespondenceThread()
      }
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    }
  }
}
</script>
